module.exports = __webpack_public_path__ + "static/printedproduct-f94db6f13e3149496b985abf728c49c8.jpg";